import { skills } from '../../data/SkillsData'
import { AppConstants } from '../../AppConstants'
import styles from './TempSkills.module.css'
import Reveal from '../Reveal/Reveal'
import SectionTitle from '../SectionTitle/SectionTitle'

const TempSkill = () => {
    return (
        <section className={styles.wrapper} id='skills'>
            <Reveal>
                <div className='container'>
                    <SectionTitle>
                        <span>{AppConstants.CommonWords.My}</span> {AppConstants.NavigationMenus.Skills}
                    </SectionTitle>
                    <div className={styles['Skill-container']}>
                        {
                            skills.map((skill) => {
                                return (
                                    <div className={styles.skills} key={skill.title}>
                                        <div className={styles['skills-title']}>{skill.title}</div>
                                        <div className={styles['skills-list']}>
                                            {
                                                skill.skills.map((item) => {
                                                    return (
                                                        <div className={styles.bar} key={item.name}>
                                                            <div className={styles.label}>
                                                                {item.icon}
                                                                <span className={styles['skill-name-cnt']}>{item.name}</span>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </Reveal>
        </section>
    )
}

export default TempSkill
